<h2 class="mt-3 mb-4">Add Contracts</h2>
<div class="notice notice-error" *ngIf="error">
  <div class="notice-body">Failed to add contract<br>{{ error?.description }}</div>
</div>
<div class="notice" *ngIf="success">
  <div class="notice-body">Successfully added contract</div>
</div>

<form [formGroup]="AddContractsForm" class="material-form-grid">
  <mat-form-field appearance="fill">
    <mat-label>Contract/Agreement No</mat-label>
    <input matInput id="agreement" type="number" formControlName="contractNo" min="0" step="1" max="9999" />
  </mat-form-field>

  <app-all-seeing-eye label="Contract Password" formControlName="password"
    hintText="You can find this on your entitlement document"></app-all-seeing-eye>

  <div class="form-actions full-width">
    <button mat-flat-button color="primary" id="add-contract-button" type="button" (click)="addContract()"
      [disabled]="addContractDisabled()">
      <mat-spinner *ngIf="adding" diameter="20" mode="indeterminate"></mat-spinner>
      {{ adding ? 'Adding' : 'Add Contract' }}
    </button>
  </div>
</form>
